(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6899],{

/***/ 46304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ PrimeDiscountText; },
/* harmony export */   "i": function() { return /* binding */ DiscountTagBase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3854);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    color: ",
        ";\n    width: auto;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    color: ",
        ";\n    text-transform: lowercase;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  cursor: pointer;\n  display: inline-block;\n  font-weight: 700;\n  line-height: 20px;\n  font-size: 14px;\n\n  text-align: start;\n  min-width: 65px;\n  padding-block: 4px;\n  padding-inline: 20px 6px;\n  border-start-end-radius: 8px;\n  border-end-end-radius: 8px;\n  border-end-start-radius: 0;\n  border-start-start-radius: 0;\n  margin-block-start: 0;\n  margin-block-end: 6px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n\n  svg {\n    fill: ",
        ";\n    margin-inline-end: 6px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

function getPromo(color, background) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject(), background, color);
}
function getTemplate(param) {
    var prime = param.prime, theme = param.theme;
    if (prime === true) {
        return getPromo(theme.colors.grey8, theme.colors.prime1);
    }
    var bgColor = theme.colors.brand1;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1(), bgColor, theme.colors.grey8);
}
var DiscountTagBase = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__DiscountTagBase",
    componentId: "sc-7c9fd3ad-0"
})(_templateObject2(), function(props) {
    return getTemplate(props);
});
var PrimeDiscountText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__PrimeDiscountText",
    componentId: "sc-7c9fd3ad-1"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.grey8;
});


/***/ }),

/***/ 1987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



var propTypes = {
    html: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired)
};
// eslint-disable-next-line react/no-danger
var HtmlViewer = function(param) {
    var html = param.html;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};
HtmlViewer.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["Z"] = (HtmlViewer);


/***/ }),

/***/ 30880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87394);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _s4l_react_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67048);
/* harmony import */ var _s4l_ds__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79000);
/* harmony import */ var client_components_Price__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50992);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43854);







var getBattlefaceLabel = function(key) {
    var labelMap = {
        battleface_tripCancellation: "insurance-package.essential",
        battleface_base: "insurance-package.advanced",
        battleface_comprehensive: "insurance-package.complete"
    };
    var baseKey = key.includes("_") ? key.slice(0, key.lastIndexOf("_")) : key;
    return labelMap[baseKey] || key;
};
var TravelInsuranceLine = function(param) {
    var additionalProducts = param.additionalProducts, currency = param.currency;
    var i18n = (0,_s4l_react_context__WEBPACK_IMPORTED_MODULE_2__/* .useS4LContext */ .ms)().i18n;
    var battlefaceProducts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return additionalProducts ? Object.entries(additionalProducts).filter(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
            return key.startsWith("battleface") && typeof value === "number" && value > 0;
        }) : [];
    }, [
        additionalProducts
    ]);
    if (battlefaceProducts.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: battlefaceProducts.map(function(param, index) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .Line */ .x1, {
                variant: index < battlefaceProducts.length - 1 ? "nopadding" : undefined,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_s4l_ds__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                        variant: "body",
                        size: "l",
                        children: i18n.formatMessage({
                            id: "insurance-package.summary"
                        }, {
                            insurance: i18n.formatMessage({
                                id: getBattlefaceLabel(key)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_s4l_ds__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                        variant: "body",
                        size: "l",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            amount: value,
                            currency: currency
                        })
                    })
                ]
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TravelInsuranceLine);


/***/ }),

/***/ 60944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ VARIANT_SIMPLE; }
/* harmony export */ });
/* unused harmony export VARIANTS */
var VARIANT_SIMPLE = "simple";
var VARIANTS = [
    VARIANT_SIMPLE
];


/***/ }),

/***/ 96540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DH": function() { return /* binding */ LineStaywallet; },
/* harmony export */   "T4": function() { return /* binding */ LineInsurance; },
/* harmony export */   "Zi": function() { return /* binding */ LineTotalPrice; },
/* harmony export */   "ce": function() { return /* binding */ LineAdditionalFees; },
/* harmony export */   "hz": function() { return /* binding */ LineTaxes; },
/* harmony export */   "yf": function() { return /* binding */ LinePriceDropProtect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(83112);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60944);
/* harmony import */ var client_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30796);
/* harmony import */ var src_comps_CheckoutWalletSelector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40401);
/* harmony import */ var client_icons_Help__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92308);
/* harmony import */ var client_components_Price__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50992);
/* harmony import */ var src_comps_MessageBox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14686);
/* harmony import */ var _TravelInsuranceLine__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30880);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(55313);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43854);
/* harmony import */ var _s4l_ds__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79000);
/* harmony import */ var _s4l_utils_hooks_useUseCase__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7349);
/* harmony import */ var debug__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25130);
/* harmony import */ var debug__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(debug__WEBPACK_IMPORTED_MODULE_12__);
/* eslint-disable react/no-array-index-key */ 
















var log = debug__WEBPACK_IMPORTED_MODULE_12___default()("s4l:stayforlong_com:LineTaxes");
var LineTaxes = function(param) {
    var taxes = param.taxes, taxesCurrency = param.taxesCurrency;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    return taxes ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Line */ .x1, {
        "data-testid": "taxes",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .TaxesWrapper */ .uC, {
                children: [
                    intl.formatMessage({
                        id: "global.taxes-fees"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_s4l_ds__WEBPACK_IMPORTED_MODULE_10__/* .BottomSheet */ .R1, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_s4l_ds__WEBPACK_IMPORTED_MODULE_10__/* .BottomSheet.Trigger */ .R1.Trigger, {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().trigger),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Help__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    size: 20
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_s4l_ds__WEBPACK_IMPORTED_MODULE_10__/* .BottomSheet.Content */ .R1.Content, {
                                title: intl.formatMessage({
                                    id: "global.taxes-fees"
                                }),
                                "data-testid": "taxes-modal",
                                size: "s",
                                modalOnDesktop: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .TaxesModalWrapper */ .Hz, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: intl.formatMessage({
                                            id: "global.taxes-fees-information"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Amount */ .$d, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    amount: taxes,
                    currency: taxesCurrency
                })
            })
        ]
    }) : null;
};
var LineRoom = function(param) {
    var nights = param.nights, subtotal = param.subtotal, subtotalCurrency = param.subtotalCurrency, _showDiscount = param.showDiscount, showDiscount = _showDiscount === void 0 ? true : _showDiscount;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    var valueNights = {
        nights: nights
    };
    var valuePricePerNighs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            amount: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                amount: Math.round(subtotal / nights),
                currency: subtotalCurrency
            })
        };
    }, [
        nights,
        subtotal,
        subtotalCurrency
    ]);
    return nights ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Line */ .x1, {
        variant: showDiscount ? "nopadding" : undefined,
        "data-testid": "subtotal",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .LineRoomResume */ .RG, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: intl.formatMessage({
                            id: "global.nights"
                        }, valueNights)
                    }),
                    showDiscount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: intl.formatMessage({
                            id: "global.price-per-night-including"
                        }, valuePricePerNighs)
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Amount */ .$d, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    amount: subtotal,
                    currency: subtotalCurrency
                })
            })
        ]
    }) : null;
};
var LineDiscount = function(param) {
    var bighead = param.bighead, isPrime = param.isPrime, isVoucher = param.isVoucher, paymentPolicy = param.paymentPolicy, sellingRate = param.sellingRate, sellingRateCurrency = param.sellingRateCurrency, showDiscount = param.showDiscount;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    var ref = (0,_s4l_utils_hooks_useUseCase__WEBPACK_IMPORTED_MODULE_11__/* .useUseCase */ .a)("GetCurrentPromoMarketingUseCase"), promo = ref.data, loading = ref.loading, error = ref.error;
    if (error) {
        log("Error calling GetCurrentPromoMarketingUseCase");
    }
    var isRatesActive = promo && !promo.tag.isEmpty();
    var discount = sellingRate - bighead;
    var valuePercent = {
        discount: "-".concat((0,client_utils__WEBPACK_IMPORTED_MODULE_3__/* .calculateDiscount */ .Et)(sellingRate, bighead), "%"),
        amount: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                amount: discount,
                currency: sellingRateCurrency
            })
        })
    };
    return discount < 0 && showDiscount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Line */ .x1, {
        "data-testid": "discount",
        "data-state": loading ? "line-discount-loading" : "line-discount-loaded",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .DiscountText */ .Vr, {
            prime: isPrime,
            children: [
                !isVoucher && isRatesActive && paymentPolicy !== "NOR" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .PromoText */ .nF, {
                    color: "#444",
                    children: [
                        intl.formatMessage({
                            id: promo.tag.text
                        }),
                        ": "
                    ]
                }) : null,
                intl.formatMessage({
                    id: "global.discount-off"
                }, valuePercent)
            ]
        })
    }) : null;
};
var LineStaywallet = function(param) {
    var staywallet = param.staywallet, staywalletCurrency = param.staywalletCurrency, variant = param.variant;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    return staywallet && variant !== _constants__WEBPACK_IMPORTED_MODULE_2__/* .VARIANT_SIMPLE */ .R ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Line */ .x1, {
        "data-testid": "staywallet",
        variant: "subtract",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: intl.formatMessage({
                    id: "staywallet.credit"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Amount */ .$d, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    amount: -staywallet,
                    currency: staywalletCurrency
                })
            })
        ]
    }) : null;
};
var LineInsurance = function(param) {
    var insurance = param.insurance, insuranceCurrency = param.insuranceCurrency, variant = param.variant;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    return insurance && variant !== _constants__WEBPACK_IMPORTED_MODULE_2__/* .VARIANT_SIMPLE */ .R ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Line */ .x1, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: intl.formatMessage({
                    id: "insurance.refund-protect"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Amount */ .$d, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    amount: insurance,
                    currency: insuranceCurrency
                })
            })
        ]
    }) : null;
};
var LinePriceDropProtect = function(param) {
    var pdp = param.pdp, pdpCurrency = param.pdpCurrency, variant = param.variant;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    return pdp && variant !== _constants__WEBPACK_IMPORTED_MODULE_2__/* .VARIANT_SIMPLE */ .R ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Line */ .x1, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: intl.formatMessage({
                    id: "insurance.price-drop-protection"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Amount */ .$d, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    amount: pdp,
                    currency: pdpCurrency
                })
            })
        ]
    }) : null;
};
var LineAdditionalFees = function(param) {
    var additionalFees = param.additionalFees, isVoucher = param.isVoucher, _simple = param.simple, simple = _simple === void 0 ? false : _simple;
    var ref, ref1;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    if (!additionalFees) {
        return null;
    }
    var additionalFeesWithAmount = additionalFees.filter(function(additionalFee) {
        return additionalFee.amount > 0;
    });
    if (additionalFeesWithAmount.length < 1) {
        return null;
    }
    var totalAdditionalFees = additionalFeesWithAmount.reduce(function(totalAddFees, currentAddFees) {
        var ref, ref1, ref2;
        if (!totalAddFees) {
            return currentAddFees;
        }
        var amount = totalAddFees.amount + currentAddFees.amount;
        var local;
        if ((totalAddFees === null || totalAddFees === void 0 ? void 0 : (ref = totalAddFees.local) === null || ref === void 0 ? void 0 : ref.amount) && (currentAddFees === null || currentAddFees === void 0 ? void 0 : (ref1 = currentAddFees.local) === null || ref1 === void 0 ? void 0 : ref1.amount)) {
            var ref3, ref4;
            var localAmount = (totalAddFees === null || totalAddFees === void 0 ? void 0 : (ref3 = totalAddFees.local) === null || ref3 === void 0 ? void 0 : ref3.amount) + (currentAddFees === null || currentAddFees === void 0 ? void 0 : (ref4 = currentAddFees.local) === null || ref4 === void 0 ? void 0 : ref4.amount);
            local = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, totalAddFees === null || totalAddFees === void 0 ? void 0 : totalAddFees.local), {
                amount: localAmount
            });
        }
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, currentAddFees, totalAddFees), {
            amount: amount
        }), (currentAddFees === null || currentAddFees === void 0 ? void 0 : (ref2 = currentAddFees.local) === null || ref2 === void 0 ? void 0 : ref2.amount) && {
            local: local
        });
    });
    var ref2;
    var amount = isVoucher ? (ref2 = totalAdditionalFees === null || totalAdditionalFees === void 0 ? void 0 : (ref = totalAdditionalFees.local) === null || ref === void 0 ? void 0 : ref.amount) !== null && ref2 !== void 0 ? ref2 : totalAdditionalFees.amount : totalAdditionalFees.amount;
    var roundedAmount = Math.round(amount);
    var ref3;
    var currency = isVoucher ? (ref3 = totalAdditionalFees === null || totalAdditionalFees === void 0 ? void 0 : (ref1 = totalAdditionalFees.local) === null || ref1 === void 0 ? void 0 : ref1.currency) !== null && ref3 !== void 0 ? ref3 : totalAdditionalFees.currency : totalAdditionalFees.currency;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .LineAdditionalFeesBase */ .Hp, {
        "data-testid": "additionalFees",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: simple ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: intl.formatMessage({
                                id: "global.due-at-property"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Note */ .jC, {
                            children: intl.formatMessage({
                                id: "global.charged-in-arrival"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: intl.formatMessage({
                                id: "global.destination-fee"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Note */ .jC, {
                            children: intl.formatMessage({
                                id: "global.due-at-property"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Amount */ .$d, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    amount: isVoucher ? amount : roundedAmount,
                    currency: currency
                })
            })
        ]
    });
};
var LineTotalPrice = function(param) {
    var total = param.total, totalCurrency = param.totalCurrency, className = param.className;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Line */ .x1, {
        className: className,
        "data-testid": "total",
        variant: "total",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: intl.formatMessage({
                    id: "global.total"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Amount */ .$d, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    amount: total >= 0 ? Math.round(total) : 0,
                    currency: totalCurrency
                })
            })
        ]
    });
};
var PriceDetails = function(param) {
    var additionalFees = param.additionalFees, additionalProducts = param.additionalProducts, bighead = param.bighead, insurance = param.insurance, insuranceCurrency = param.insuranceCurrency, isPrime = param.isPrime, isVoucher = param.isVoucher, nights = param.nights, payDate = param.payDate, payLate = param.payLate, payNow = param.payNow, paymentPolicy = param.paymentPolicy, pdp = param.pdp, pdpCurrency = param.pdpCurrency, purchaseId = param.purchaseId, sellingRate = param.sellingRate, sellingRateCurrency = param.sellingRateCurrency, _showDiscount = param.showDiscount, showDiscount = _showDiscount === void 0 ? true : _showDiscount, _showPaymentDates = param.showPaymentDates, showPaymentDates = _showPaymentDates === void 0 ? true : _showPaymentDates, showWalletCheckbox = param.showWalletCheckbox, staywallet = param.staywallet, staywalletCurrency = param.staywalletCurrency, subtotal = param.subtotal, subtotalCurrency = param.subtotalCurrency, taxes = param.taxes, taxesCurrency = param.taxesCurrency, total = param.total, totalCurrency = param.totalCurrency, totalWithFees = param.totalWithFees, variant = param.variant;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    var dateText = intl.formatDate(payDate, {
        year: "numeric",
        month: "long",
        day: "2-digit"
    });
    var valuePayDate = {
        date: dateText
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .PriceDetailsBase */ .Sv, {
        "data-testid": "price-details",
        children: [
            variant !== _constants__WEBPACK_IMPORTED_MODULE_2__/* .VARIANT_SIMPLE */ .R && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Title */ .Dx, {
                children: intl.formatMessage({
                    id: isVoucher ? "global.price" : "global.price-breakdown"
                })
            }),
            showWalletCheckbox && purchaseId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_CheckoutWalletSelector__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                purchaseId: purchaseId
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LineRoom, {
                nights: nights,
                subtotal: subtotal,
                subtotalCurrency: subtotalCurrency,
                showDiscount: showDiscount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LineDiscount, {
                bighead: bighead,
                isPrime: isPrime,
                isVoucher: isVoucher,
                paymentPolicy: paymentPolicy,
                sellingRate: sellingRate,
                sellingRateCurrency: sellingRateCurrency,
                showDiscount: showDiscount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LineTaxes, {
                taxes: taxes,
                taxesCurrency: taxesCurrency
            }),
            !isVoucher ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LineAdditionalFees, {
                additionalFees: additionalFees,
                isVoucher: isVoucher
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LineStaywallet, {
                staywallet: staywallet,
                staywalletCurrency: staywalletCurrency,
                variant: variant
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TravelInsuranceLine__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                additionalProducts: additionalProducts,
                currency: totalCurrency
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LineInsurance, {
                insurance: insurance,
                insuranceCurrency: insuranceCurrency,
                variant: variant
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinePriceDropProtect, {
                pdp: pdp,
                pdpCurrency: pdpCurrency,
                variant: variant
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LineTotalPrice, {
                total: totalWithFees !== null && totalWithFees !== void 0 ? totalWithFees : total,
                totalCurrency: totalCurrency
            }),
            isVoucher ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LineAdditionalFees, {
                additionalFees: additionalFees,
                isVoucher: isVoucher
            }) : null,
            variant !== _constants__WEBPACK_IMPORTED_MODULE_2__/* .VARIANT_SIMPLE */ .R && payNow >= 0 && payNow !== (totalWithFees !== null && totalWithFees !== void 0 ? totalWithFees : total) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Line */ .x1, {
                variant: "rate",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: intl.formatMessage({
                            id: "global.now-pay"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Amount */ .$d, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            amount: payNow,
                            currency: sellingRateCurrency
                        })
                    })
                ]
            }) : null,
            variant !== _constants__WEBPACK_IMPORTED_MODULE_2__/* .VARIANT_SIMPLE */ .R && showPaymentDates && payLate && payDate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Line */ .x1, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: intl.formatMessage({
                            id: "global.you-will-pay"
                        }, valuePayDate)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_9__/* .Amount */ .$d, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            amount: payLate,
                            currency: sellingRateCurrency
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_MessageBox__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                message: intl.formatMessage({
                    id: "global.currency-charge"
                }),
                type: "info"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (PriceDetails);


/***/ }),

/***/ 43854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$d": function() { return /* binding */ Amount; },
  "Vr": function() { return /* binding */ DiscountText; },
  "x1": function() { return /* binding */ Line; },
  "Hp": function() { return /* binding */ LineAdditionalFeesBase; },
  "RG": function() { return /* binding */ LineRoomResume; },
  "jC": function() { return /* binding */ Note; },
  "Sv": function() { return /* binding */ PriceDetailsBase; },
  "nF": function() { return /* binding */ PromoText; },
  "Hz": function() { return /* binding */ TaxesModalWrapper; },
  "uC": function() { return /* binding */ TaxesWrapper; },
  "Dx": function() { return /* binding */ Title; }
});

// UNUSED EXPORTS: Room

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(3854);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./client/components/Tag/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  border-radius: 3px;\n  padding-block: 4px;\n  padding-inline: 6px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  svg {\n    display: inline-block;\n    fill: ",
        ";\n    margin-inline-end: 5px;\n  }\n  p {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          p {\n            ",
        "\n          }\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        "\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: inline-flex;\n  font-weight: ",
        ";\n\n  svg {\n    display: inline-block;\n    fill: ",
        ";\n    margin-inline-end: 5px;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var pillStyle = (0,styled_components_browser_esm/* css */.iv)(_templateObject(), function(props) {
    return props.color ? props.color : styles/* colors.white */.O9.white;
}, function(props) {
    return props.background ? props.background : styles/* colors.magenta */.O9.magenta;
});
var primeStyle = (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), styles/* colors.purple2 */.O9.purple2, styles/* colors.white */.O9.white, styles/* colors.purple2 */.O9.purple2);
var TagBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TagBase",
    componentId: "sc-cd641d0b-0"
})(_templateObject4(), function(props) {
    return props.bold && "700";
}, function(props) {
    return styles/* colors */.O9[props.background];
}, function(props) {
    return props.withIcon ? (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), pillStyle) : (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), pillStyle);
}, function(props) {
    return props.prime && primeStyle;
});

// EXTERNAL MODULE: ./client/components/DiscountTag/styles.tsx
var DiscountTag_styles = __webpack_require__(46304);
// EXTERNAL MODULE: ./src/comps/AdditionalFees/styles.js
var AdditionalFees_styles = __webpack_require__(9163);
// EXTERNAL MODULE: ./src/comps/CheckoutWalletSelector/styles.js
var CheckoutWalletSelector_styles = __webpack_require__(55028);
;// CONCATENATED MODULE: ./client/components/PriceDetails/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      align-items: center;\n      font-weight: 700;\n      color: ",
        ";\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-weight: 700;\n    "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-block-start: 1px solid ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n      padding-block-start: 16px;\n      padding-block-end: 0;\n\n      &:not(:last-child) {\n        margin-block-end: 12px;\n      }\n    "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-block-end: 0;\n    "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-block-start: 1px solid ",
        ";\n      color: ",
        ";\n      padding-block-start: 16px;\n      font-weight: 700;\n      &:last-child {\n        padding-block-end: 0;\n      }\n    "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-block-end: 8px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    &:last-child {\n      padding-block-end: 0;\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n\n  ",
        " {\n    margin-inline-start: -20px;\n    padding-inline-start: 20px;\n    border-start-end-radius: 0;\n    border-end-end-radius: 8px;\n    border-end-start-radius: 8px;\n    border-start-start-radius: 0;\n  }\n\n  ",
        " {\n    margin-inline-start: -20px;\n    padding-inline-start: 20px;\n    width: auto;\n  }\n\n  ",
        " {\n    margin-block: 8px 16px;\n    margin-inline: 0;\n  }\n\n  ",
        " {\n    margin-block-end: 16px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  text-align: end;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 16px;\n  justify-content: space-between;\n  line-height: 1.4;\n  padding-block-end: 16px;\n  ",
        "\n\n  p {\n    flex: 1 1 auto;\n  }\n\n  ",
        " {\n    flex: 0 0 auto;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 21px;\n  font-weight: 700;\n  padding-block: 0 20px;\n  padding-inline: 0;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: break-spaces;\n  text-transform: lowercase;\n\n  span {\n    text-transform: none;\n    font-size: 14px;\n    line-height: 1.4em;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  line-height: 1.3;\n  svg {\n    cursor: pointer;\n    margin-inline-start: 10px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 1.4em;\n\n  span {\n    font-weight: 700;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  color: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 14px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}






function getLineVariant(variant) {
    if (variant === "subtract") {
        return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject(), styles/* colors.magenta */.O9.magenta);
    }
    if (variant === "bold") {
        return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject1());
    }
    if (variant === "rate") {
        return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject2(), styles/* colors.grey4 */.O9.grey4, styles/* colors.grey1 */.O9.grey1);
    }
    if (variant === "nopadding") {
        return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject3());
    }
    if (variant === "total") {
        return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject4(), styles/* colors.grey4 */.O9.grey4, styles/* colors.grey1 */.O9.grey1);
    }
    if (variant === "pay") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), styles/* colors.grey2 */.O9.grey2);
}
var PriceDetailsBase = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__PriceDetailsBase",
    componentId: "sc-f03d1528-0"
})(_templateObject7(), styles/* colors.white */.O9.white, styles/* colors.grey2 */.O9.grey2, TagBase, DiscountTag_styles/* DiscountTagBase */.i, AdditionalFees_styles/* AdditionalFeesBase */.n_, CheckoutWalletSelector_styles/* CheckoutWalletSelectorBase */.P);
var Amount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__Amount",
    componentId: "sc-f03d1528-1"
})(_templateObject8(), function(props) {
    return props.promoColor && "color: ".concat(styles/* colors.black */.O9.black);
}, function(props) {
    return props.prime && "color: ".concat(styles/* colors.purple2 */.O9.purple2);
});
var Line = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Line",
    componentId: "sc-f03d1528-2"
})(_templateObject9(), function(param) {
    var variant = param.variant;
    return getLineVariant(variant);
}, Amount);
var LineAdditionalFeesBase = (0,styled_components_browser_esm/* default */.ZP)(Line).withConfig({
    displayName: "styles__LineAdditionalFeesBase",
    componentId: "sc-f03d1528-3"
})(_templateObject10());
var Title = (0,styled_components_browser_esm/* default */.ZP)(Line).withConfig({
    displayName: "styles__Title",
    componentId: "sc-f03d1528-4"
})(_templateObject11(), styles/* colors.grey1 */.O9.grey1);
var LineRoomResume = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LineRoomResume",
    componentId: "sc-f03d1528-5"
})(_templateObject12());
var Room = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__Room",
    componentId: "sc-f03d1528-6"
})(_templateObject13(), function(props) {
    return props.isCancelled && " text-decoration: line-through";
});
var TaxesWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TaxesWrapper",
    componentId: "sc-f03d1528-7"
})(_templateObject14());
var TaxesModalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TaxesModalWrapper",
    componentId: "sc-f03d1528-8"
})(_templateObject15());
var DiscountText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DiscountText",
    componentId: "sc-f03d1528-9"
})(_templateObject16(), function(props) {
    return props.prime ? props.theme.colors.prime2 : props.theme.colors.brand1;
});
var _color;
var PromoText = styled_components_browser_esm/* default.b.withConfig */.ZP.b.withConfig({
    displayName: "styles__PromoText",
    componentId: "sc-f03d1528-10"
})(_templateObject17(), function(props) {
    return (_color = props.color) !== null && _color !== void 0 ? _color : props.theme.colors.brand1;
});
var Note = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__Note",
    componentId: "sc-f03d1528-11"
})(_templateObject18(), function(props) {
    return props.theme.colors.grey3;
});


/***/ }),

/***/ 76855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57058);



var BoardIcon = function(param) {
    var code = param.code;
    var item = _index__WEBPACK_IMPORTED_MODULE_2__/* .codeBoardMap.get */ .Un.get(code);
    var Icon = item === null || item === void 0 ? void 0 : item.icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: Icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
            size: 16
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BoardIcon);


/***/ }),

/***/ 57058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U_": function() { return /* binding */ isAllInclusive; },
/* harmony export */   "Un": function() { return /* binding */ codeBoardMap; },
/* harmony export */   "fr": function() { return /* binding */ hasBreakfast; }
/* harmony export */ });
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);

var IconBedAndBreakfast = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 1437).then(__webpack_require__.bind(__webpack_require__, 41437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41437)
            ];
        }
    }
});
var IconLunch = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 3705).then(__webpack_require__.bind(__webpack_require__, 53705));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53705)
            ];
        }
    }
});
var IconLunchAndDrink = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 9700).then(__webpack_require__.bind(__webpack_require__, 19700));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19700)
            ];
        }
    }
});
var IconSelfCatering = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 5220).then(__webpack_require__.bind(__webpack_require__, 35220));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35220)
            ];
        }
    }
});
var IconFullKitchen = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 9732).then(__webpack_require__.bind(__webpack_require__, 89732));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89732)
            ];
        }
    }
});
var IconAllInclusive = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 181).then(__webpack_require__.bind(__webpack_require__, 50181));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50181)
            ];
        }
    }
});
var IconRoomOnly = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 4061).then(__webpack_require__.bind(__webpack_require__, 4061));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4061)
            ];
        }
    }
});
var codeBoardMap = new Map([
    [
        "AB",
        {
            key: "breakfast",
            name: "global.breakfast",
            icon: IconBedAndBreakfast,
            description: "board.breakfast"
        }, 
    ],
    [
        "AI",
        {
            key: "all-inclusive",
            name: "global.all-inclusive",
            icon: IconAllInclusive,
            description: "board.all-inclusive"
        }, 
    ],
    [
        "AS",
        {
            key: "all-inclusive",
            name: "global.all-inclusive",
            icon: IconAllInclusive,
            description: "board.special-all-inclusive"
        }, 
    ],
    [
        "BB",
        {
            key: "breakfast",
            name: "global.breakfast",
            icon: IconBedAndBreakfast,
            description: "board.breakfast"
        }, 
    ],
    [
        "BH",
        {
            key: "half-board",
            name: "global.1-breakfast-1-half-board",
            icon: IconLunch,
            description: "board.1-breakfast-1-half-board"
        }, 
    ],
    [
        "CB",
        {
            key: "breakfast",
            name: "global.breakfast",
            icon: IconBedAndBreakfast,
            description: "board.continental-breakfast"
        }, 
    ],
    [
        "DB",
        {
            key: "breakfast",
            name: "global.breakfast",
            icon: IconBedAndBreakfast,
            description: "board.breakfast"
        }, 
    ],
    [
        "FB",
        {
            key: "full-board",
            name: "global.full-board",
            icon: IconLunch,
            description: "board.full-board"
        }, 
    ],
    [
        "FH",
        {
            key: "full-board",
            name: "global.1-half-board-1-full-board",
            icon: IconLunch,
            description: "board.1-half-1-full"
        }, 
    ],
    [
        "GB",
        {
            key: "breakfast",
            name: "global.breakfast",
            icon: IconBedAndBreakfast,
            description: "board.breakfast"
        }, 
    ],
    [
        "HB",
        {
            key: "half-board",
            name: "global.half-board",
            icon: IconLunch,
            description: "board.half-board"
        }, 
    ],
    [
        "IB",
        {
            key: "breakfast",
            name: "global.breakfast",
            icon: IconBedAndBreakfast,
            description: "board.breakfast"
        }, 
    ],
    [
        "MB",
        {
            key: "half-board",
            name: "global.half-board-plus-beverages",
            icon: IconLunchAndDrink,
            description: "board.half-board-beverages"
        }, 
    ],
    [
        "PB",
        {
            key: "full-board",
            name: "global.full-board-plus-beverages",
            icon: IconLunchAndDrink,
            description: "board.full-board-beverages"
        }, 
    ],
    [
        "RO",
        {
            key: "room-only",
            name: "global.room-only",
            icon: IconRoomOnly,
            description: "global.room-only"
        }, 
    ],
    [
        "SB",
        {
            key: "breakfast",
            name: "global.breakfast",
            icon: IconBedAndBreakfast,
            description: "board.breakfast"
        }, 
    ],
    [
        "SC",
        {
            key: "self-catering",
            name: "global.self-catering",
            icon: IconSelfCatering,
            description: "board.self-catering"
        }, 
    ],
    [
        "B1",
        {
            key: "breakfast",
            name: "global.breakfast-for-1",
            icon: IconBedAndBreakfast,
            description: "board.breakfast-for-1"
        }, 
    ],
    [
        "B2",
        {
            key: "breakfast",
            name: "global.breakfast-for-2",
            icon: IconBedAndBreakfast,
            description: "board.breakfast-for-2"
        }, 
    ],
    [
        "BD",
        {
            key: "half-board",
            name: "global.half-board",
            icon: IconLunch,
            description: "board.half-board"
        }, 
    ],
    [
        "CAB",
        {
            key: "breakfast",
            name: "global.breakfast",
            icon: IconBedAndBreakfast,
            description: "board.breakfast"
        }, 
    ],
    [
        "CE",
        {
            key: "dinner",
            name: "global.dinner",
            icon: IconLunch,
            description: "board.dinner"
        }
    ],
    [
        "CO",
        {
            key: "lunch",
            name: "global.lunch",
            icon: IconLunch,
            description: "board.lunch"
        }
    ],
    [
        "FD",
        {
            key: "dinner",
            name: "global.dinner",
            icon: IconLunch,
            description: "board.dinner"
        }
    ],
    [
        "FK",
        {
            key: "full-kitchen",
            name: "global.full-kitchen",
            icon: IconFullKitchen,
            description: "board.full-kitchen"
        }, 
    ],
    [
        "FL+FD",
        {
            key: "full-board",
            name: "global.full-board",
            icon: IconLunch,
            description: "board.full-board"
        }, 
    ],
    [
        "TFO",
        {
            key: "buffet",
            name: "global.buffet",
            icon: IconSelfCatering,
            description: "board.buffet"
        }, 
    ],
    [
        "FLL",
        {
            key: "lunch",
            name: "global.lunch",
            icon: IconLunch,
            description: "board.lunch"
        }
    ],
    [
        "SAI",
        {
            key: "all-inclusive",
            name: "global.soft-all-inclusive",
            icon: IconAllInclusive,
            description: "board.soft-inclusive"
        }, 
    ],
    [
        "BL",
        {
            key: "half-board",
            name: "global.half-board",
            icon: IconLunch,
            description: "board.breakfast-lunch"
        }, 
    ], 
]);
var hasBreakfast = function(code) {
    var ref, ref1, ref2, ref3, ref4;
    return ((ref = codeBoardMap.get(code)) === null || ref === void 0 ? void 0 : ref.key) === "breakfast" || ((ref1 = codeBoardMap.get(code)) === null || ref1 === void 0 ? void 0 : ref1.key) === "half-board" || ((ref2 = codeBoardMap.get(code)) === null || ref2 === void 0 ? void 0 : ref2.key) === "full-board" || ((ref3 = codeBoardMap.get(code)) === null || ref3 === void 0 ? void 0 : ref3.key) === "all-inclusive" || ((ref4 = codeBoardMap.get(code)) === null || ref4 === void 0 ? void 0 : ref4.key) === "soft-all-inclusive";
};
var isAllInclusive = function(code) {
    var ref, ref1;
    return ((ref = codeBoardMap.get(code)) === null || ref === void 0 ? void 0 : ref.key) === "all-inclusive" || ((ref1 = codeBoardMap.get(code)) === null || ref1 === void 0 ? void 0 : ref1.key) === "soft-all-inclusive";
};


/***/ }),

/***/ 14346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y$": function() { return /* binding */ RateNORPaymentDescription; },
/* harmony export */   "f3": function() { return /* binding */ RateNORCancellationDescription; }
/* harmony export */ });
/* unused harmony exports RateNORPayment, RateNORCancelation */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83112);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12524);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var client_icons_Checkmark__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43476);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80646);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var src_comps_DateIntl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59154);
/* harmony import */ var src_comps_DateIntl_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85611);








var RateNORPayment = function(param) {
    var cancellationDate = param.cancellationDate, payRate = param.payRate;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    return payRate > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().greenIcon), (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().listDoted)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Checkmark__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                size: 16
            }),
            " ",
            intl.formatMessage({
                id: "global.pay-now"
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().greenText), (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().listDoted)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Checkmark__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                size: 16
            }),
            intl.formatMessage({
                id: "policies.pay-on"
            }, {
                date: cancellationDate
            })
        ]
    });
};
var RateNORPaymentDescription = function(param) {
    var cancellation = param.cancellation, payRate = param.payRate, currency = param.currency;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var cancellationDate = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_DateIntl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        value: cancellation === null || cancellation === void 0 ? void 0 : cancellation.from,
        format: src_comps_DateIntl_constants__WEBPACK_IMPORTED_MODULE_5__/* .DATE_INTL_FORMAT_MONTH_TEXT */ .wl
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().offerConditionsList),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateNORPayment, {
                    payRate: payRate,
                    currency: currency,
                    cancellationDate: cancellationDate
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: payRate > 0 ? intl.formatMessage({
                    id: "reservation.non-refundable-offer"
                }) : intl.formatMessage({
                    id: "payment.no-prepayment"
                })
            })
        ]
    });
};
var RateNORCancelation = function(param) {
    var cancellationDate = param.cancellationDate;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().greenText),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Checkmark__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                size: 16
            }),
            intl.formatMessage({
                id: "policies.free-cancellation-before"
            }, {
                date: cancellationDate
            })
        ]
    });
};
var RateNORCancellationDescription = function(param) {
    var cancellation = param.cancellation;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var cancellationDate = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_DateIntl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        value: cancellation === null || cancellation === void 0 ? void 0 : cancellation.from,
        format: src_comps_DateIntl_constants__WEBPACK_IMPORTED_MODULE_5__/* .DATE_INTL_FORMAT_MONTH_TEXT */ .wl
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().offerConditionsList),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateNORCancelation, {
                    cancellationDate: cancellationDate
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: intl.formatMessage({
                    id: "payment.cancel-for-free-nor"
                }, {
                    date: cancellationDate
                })
            })
        ]
    });
};
var RateNOR = function(param) {
    var cancellation = param.cancellation, payRate = param.payRate, currency = param.currency;
    var cancellationDate = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_DateIntl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        value: cancellation.from,
        format: src_comps_DateIntl_constants__WEBPACK_IMPORTED_MODULE_5__/* .DATE_INTL_FORMAT_MONTH_TEXT */ .wl
    });
    return payRate > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateNORPayment, {
                payRate: payRate,
                currency: currency,
                cancellationDate: cancellationDate
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateNORCancelation, {
                cancellationDate: cancellationDate
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateNORCancelation, {
                cancellationDate: cancellationDate
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateNORPayment, {
                payRate: payRate,
                currency: currency,
                cancellationDate: cancellationDate
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (RateNOR);


/***/ }),

/***/ 58112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nm": function() { return /* binding */ RateNRFPaymentDescription; },
/* harmony export */   "Os": function() { return /* binding */ RateNRFCancellationDescription; }
/* harmony export */ });
/* unused harmony exports RateNRFPayment, RateNRFCancelation */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83112);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12524);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var client_icons_Checkmark__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43476);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80646);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_5__);






var RateNRFPayment = function() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().greenIcon), (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().listDoted)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Checkmark__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                size: 16
            }),
            " ",
            intl.formatMessage({
                id: "global.pay-now"
            })
        ]
    });
};
var RateNRFPaymentDescription = function() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().offerConditionsList),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateNRFPayment, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: intl.formatMessage({
                    id: "reservation.non-refundable-offer"
                })
            })
        ]
    });
};
var RateNRFCancelation = function() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().listDoted),
        children: intl.formatMessage({
            id: "reservation.no-refundable"
        })
    });
};
var RateNRFCancellationDescription = function() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().offerConditionsList),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateNRFCancelation, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: intl.formatMessage({
                    id: "cancelation.no-refundable"
                })
            })
        ]
    });
};
var RateNRF = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateNRFPayment, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateNRFCancelation, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (RateNRF);


/***/ }),

/***/ 26613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kt": function() { return /* binding */ RateSFLCancellationDescription; },
/* harmony export */   "mN": function() { return /* binding */ RateSFLPaymentDescription; }
/* harmony export */ });
/* unused harmony exports RateSFLPayment, RateSFLCancelation */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83112);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12524);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var client_components_Price__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50992);
/* harmony import */ var client_icons_Checkmark__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43476);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80646);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var src_comps_DateIntl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59154);
/* harmony import */ var src_comps_DateIntl_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85611);









var RateSFLPayment = function(param) {
    var cancellationDate = param.cancellationDate, payRate = param.payRate, currency = param.currency;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().greenText), (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().listDoted)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Checkmark__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        size: 16
                    }),
                    intl.formatMessage({
                        id: "room.pay-partial"
                    }, {
                        pay_rate: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            amount: payRate,
                            currency: currency
                        })
                    }),
                    " (".concat(intl.formatMessage({
                        id: "policies.deposit"
                    }), ")")
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().greenText), (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().listDoted)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Checkmark__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        size: 16
                    }),
                    intl.formatMessage({
                        id: "policies.pay-the-rest-on"
                    }, {
                        date: cancellationDate
                    })
                ]
            })
        ]
    });
};
var RateSFLPaymentDescription = function(param) {
    var cancellation = param.cancellation, payRate = param.payRate, currency = param.currency;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var cancellationDate = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_DateIntl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        value: cancellation === null || cancellation === void 0 ? void 0 : cancellation.from,
        format: src_comps_DateIntl_constants__WEBPACK_IMPORTED_MODULE_6__/* .DATE_INTL_FORMAT_MONTH_TEXT */ .wl
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().offerConditionsList),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateSFLPayment, {
                    payRate: payRate,
                    currency: currency,
                    cancellationDate: cancellationDate
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: intl.formatMessage({
                    id: "payment.deposit"
                }, {
                    price: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        amount: payRate,
                        currency: currency
                    })
                })
            })
        ]
    });
};
var RateSFLCancelation = function(param) {
    var cancellationDate = param.cancellationDate;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().greenText),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Checkmark__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                size: 16
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                children: [
                    intl.formatMessage({
                        id: "policies.cancel-until"
                    }, {
                        date: cancellationDate
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().boldBlack),
                        children: " (".concat(intl.formatMessage({
                            id: "policies.deposit-non-refundable"
                        }), ")")
                    })
                ]
            })
        ]
    });
};
var RateSFLCancellationDescription = function(param) {
    var cancellation = param.cancellation, payRate = param.payRate, currency = param.currency;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var cancellationDate = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_DateIntl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        value: cancellation === null || cancellation === void 0 ? void 0 : cancellation.from,
        format: src_comps_DateIntl_constants__WEBPACK_IMPORTED_MODULE_6__/* .DATE_INTL_FORMAT_MONTH_TEXT */ .wl
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().offerConditionsList),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateSFLCancelation, {
                    cancellationDate: cancellationDate
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: intl.formatMessage({
                    id: "payment.cancel-for-free-slf"
                }, {
                    date: cancellationDate,
                    amount: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        amount: payRate,
                        currency: currency
                    })
                })
            })
        ]
    });
};
var RateSFL = function(param) {
    var cancellation = param.cancellation, payRate = param.payRate, currency = param.currency;
    var cancellationDate = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_DateIntl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        value: cancellation.from,
        format: src_comps_DateIntl_constants__WEBPACK_IMPORTED_MODULE_6__/* .DATE_INTL_FORMAT_MONTH_TEXT */ .wl
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateSFLPayment, {
                payRate: payRate,
                currency: currency,
                cancellationDate: cancellationDate
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RateSFLCancelation, {
                cancellationDate: cancellationDate
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (RateSFL);


/***/ }),

/***/ 30874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hg": function() { return /* binding */ getWalletCredit; },
/* harmony export */   "dF": function() { return /* binding */ isFetching; },
/* harmony export */   "lq": function() { return /* binding */ isCheck; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7015);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5994);


var getWalletAmount = function(state) {
    var ref;
    return (ref = state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .WALLET_STATE */ .Mi]) === null || ref === void 0 ? void 0 : ref.amount;
};
var getWalletCurrency = function(state) {
    var ref;
    return (ref = state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .WALLET_STATE */ .Mi]) === null || ref === void 0 ? void 0 : ref.currency;
};
var isFetching = function(state) {
    var ref;
    return (ref = state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .WALLET_STATE */ .Mi]) === null || ref === void 0 ? void 0 : ref.isFetching;
};
var isCheck = function(state) {
    var ref;
    return (ref = state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .WALLET_STATE */ .Mi]) === null || ref === void 0 ? void 0 : ref.isCheck;
};
var getWalletCredit = (0,reselect__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)([
    getWalletAmount,
    getWalletCurrency
], function(amount, currency) {
    return {
        amount: amount,
        currency: currency
    };
});


/***/ }),

/***/ 43476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M10.5 18.5c-.4 0-.8-.2-1.1-.5l-5-5.5c-.6-.6-.5-1.6.1-2.1.6-.6 1.6-.5 2.1.1l3.8 4.2 6.9-9.1c.5-.7 1.4-.8 2.1-.3.7.5.8 1.4.3 2.1l-8 10.5c-.3.4-.7.6-1.2.6z"
}), "Checkmark"));


/***/ }),

/***/ 11910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M4.045 10.055c0-.2.1-.5.2-.7.4-.4 1-.5 1.4-.1l6.4 5.5 6.3-5.5c.4-.4 1.1-.3 1.4.1.4.4.3 1.1-.1 1.4l-7 6c-.4.3-.9.3-1.3 0l-7-6c-.2-.1-.3-.4-.3-.7z"
}), "ChevronDown"));


/***/ }),

/***/ 87282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M20 13.945c0 .2-.1.5-.2.7-.4.4-1 .5-1.4.1l-6.4-5.5-6.3 5.5c-.4.4-1.1.3-1.4-.1-.4-.4-.3-1.1.1-1.4l7-6c.4-.3.9-.3 1.3 0l7 6c.2.1.3.4.3.7z"
}), "ChevronUp"));


/***/ }),

/***/ 47012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5834 5.1879C20.032 5.51011 20.1344 6.13494 19.8122 6.58349L11.1922 18.5835C11.013 18.8329 10.7292 18.9862 10.4223 18.9992C10.1155 19.0122 9.8197 18.8835 9.62008 18.6501L4.24008 12.3601C3.8811 11.9404 3.93032 11.3091 4.35002 10.9501C4.76973 10.5912 5.40097 10.6404 5.75996 11.0601L10.3115 16.3815L18.1878 5.41666C18.5101 4.96811 19.1349 4.86569 19.5834 5.1879Z"
}), "Done"));


/***/ }),

/***/ 54332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M11.4 2.1c-.3-.1-.6-.1-.9 0-.3.2-.5.6-.5.9 0 0 0 2.6-1.7 4.3-.3.2-.5.5-.8.7C5.9 9.4 4 11.2 4 15c0 4.6 3.8 6.6 5.8 7 .4.1.9-.1 1.1-.5.2-.4.1-.9-.1-1.2 0 0-.7-.8-.7-2.3 0-.8.4-1.6.9-2.6.3-.5.5-1 .7-1.6 1 1.2 2.3 2.8 2.3 4.2 0 1.4-.2 1.9-.3 2.1-.4.1-.7.5-.7.9 0 .6.4 1 1 1h.1c.8-.1 5.9-.7 5.9-8 0-7.5-8.2-11.7-8.6-11.9zm4.5 17.2c0-.4.1-.8.1-1.3 0-3.4-3.9-6.5-4.4-6.8-.2-.1-.4-.2-.6-.2-.2 0-.3 0-.4.1-.4.2-.6.5-.6.9 0 .8-.4 1.6-.9 2.6S8 16.8 8 18c0 .4 0 .8.1 1.1C7 18.4 6 17.1 6 15c0-2.9 1.4-4.2 2.9-5.5l.8-.8c1.3-1.3 1.9-2.9 2.1-4.1C13.9 6 18 9.3 18 14c0 3.1-1 4.6-2.1 5.3z"
}), "Fire"));


/***/ }),

/***/ 3802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M11.998.89a11.1 11.1 0 0111.111 11.096c.012 6.143-4.957 11.12-11.108 11.123C5.855 23.113.874 18.125.89 11.986.904 5.84 5.86.89 11.998.89zm9.092 11.126a9.078 9.078 0 00-9.078-9.104 9.074 9.074 0 00-9.1 9.082 9.077 9.077 0 009.09 9.096c5.01.008 9.081-4.056 9.088-9.074zm-10.357 2.262v-.83c-.002-.553-.002-1.107 0-1.66.004-.565.27-.98.785-1.204.483-.21.935-.112 1.328.232.28.247.415.568.418.938.004 1.676.008 3.35-.003 5.025A1.268 1.268 0 0112 18.062c-.703 0-1.26-.561-1.268-1.301-.005-.551-.003-1.104-.002-1.656l.002-.827zm2.787-6.801c.019-.823-.67-1.533-1.5-1.544-.83-.011-1.529.669-1.54 1.499a1.528 1.528 0 001.51 1.533 1.53 1.53 0 001.53-1.488z"
}), "Info"));


/***/ }),

/***/ 68436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M17 2H7C6.45 2 6 2.45 6 3V21C6 21.55 6.45 22 7 22H17C17.55 22 18 21.55 18 21V3C18 2.45 17.55 2 17 2ZM8 7H16V17H8V7ZM16 4V5H8V4H16ZM8 20V19H16V20H8Z"
}), "MobilePhone"));


/***/ }),

/***/ 73045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M17 8c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5 5 2.2 5 5zm-2 0c0-1.7-1.3-3-3-3S9 6.3 9 8s1.3 3 3 3 3-1.3 3-3zM3 19c0-2.2 1.8-4 4-4h10c2.2 0 4 1.8 4 4v1c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-1zm2 0v1h14v-1c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2z"
}), "Person"));


/***/ }),

/***/ 45920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M12.6 2.19998C12.6 2.19998 16.4 5.09998 20.2 5.99998C20.7 6.09998 21 6.49998 21 6.99998V11C21 18.6 12.7 21.8 12.4 21.9C12.2 22 12.1 22 12 22C11.9 22 11.8 22 11.6 21.9C11.3 21.8 3 18.6 3 11V6.99998C3 6.49998 3.3 6.09998 3.8 5.99998C7.5 5.09998 11.4 2.19998 11.4 2.19998C11.8 1.89998 12.2 1.89998 12.6 2.19998ZM12 19.9C13.5 19.3 19 16.4 19 11V7.79998C16 6.89998 13.2 5.09998 12 4.29998C10.8 5.09998 8 6.89998 5 7.79998V11C5 16.4 10.5 19.3 12 19.9ZM8.3 11.3C8.7 10.9 9.3 10.9 9.7 11.3L11 12.6L14.3 9.3C14.7 8.9 15.3 8.9 15.7 9.3C16.1 9.7 16.1 10.3 15.7 10.7L11.7 14.7C11.5 14.9 11.3 15 11 15C10.7 15 10.5 14.9 10.3 14.7L8.3 12.7C7.9 12.3 7.9 11.7 8.3 11.3Z"
    })
}), "Shield"));


/***/ }),

/***/ 78689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M21 12.8V6c0-1.7-1.3-3-3-3H6C4.3 3 3 4.3 3 6v6.8c-.6.5-1 1.3-1 2.2v6c0 .6.4 1 1 1s1-.4 1-1v-1h16v1c0 .6.4 1 1 1s1-.4 1-1v-6c0-.9-.4-1.7-1-2.2zM5 6c0-.6.4-1 1-1h12c.6 0 1 .4 1 1v6h-1V8c0-.6-.4-1-1-1H7c-.6 0-1 .4-1 1v4H5V6zm3 6V9h3v3H8zm5-3h3v3h-3V9zm-9 9v-3c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v3H4z"
}), "DoubleBed"));


/***/ }),

/***/ 64974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M20 12.2V6C20 4.3 18.7 3 17 3H7C5.3 3 4 4.3 4 6V12.2C2.8 12.6 2 13.7 2 15V21C2 21.6 2.4 22 3 22C3.6 22 4 21.6 4 21V20H20V21C20 21.6 20.4 22 21 22C21.6 22 22 21.6 22 21V15C22 13.7 21.2 12.6 20 12.2ZM6 6C6 5.4 6.4 5 7 5H17C17.6 5 18 5.4 18 6V12H16V8C16 7.4 15.6 7 15 7H9C8.4 7 8 7.4 8 8V12H6V6ZM14 12H10V9H14V12ZM4 18V15C4 14.4 4.4 14 5 14H9H15H19C19.6 14 20 14.4 20 15V18H4Z"
}), "SingleBed"));


/***/ }),

/***/ 10306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bl": function() { return /* binding */ areSameAges; },
/* harmony export */   "jD": function() { return /* binding */ convertAgesToArray; },
/* harmony export */   "ts": function() { return /* binding */ sumAgesFromString; },
/* harmony export */   "uo": function() { return /* binding */ convertAgesToString; }
/* harmony export */ });
function sumAgesFromString(ages) {
    return ages ? ages.split(",").reduce(function(prev, value) {
        return prev + parseInt(value, 10);
    }, 0) : 0;
}
function convertAgesToArray(ages) {
    return ages ? ages.split(",").map(function(age, index) {
        return {
            index: index,
            value: parseInt(age)
        };
    }) : [];
}
function convertAgesToString(ages) {
    return (ages === null || ages === void 0 ? void 0 : ages.length) ? ages.map(function(age) {
        return age.value;
    }).join(",") : "";
}
function areSameAges(ages, newAges) {
    return ages.every(function(age, index) {
        var ref;
        return age.value === ((ref = newAges.find(function(newAge) {
            return newAge.index === index;
        })) === null || ref === void 0 ? void 0 : ref.value);
    });
}


/***/ }),

/***/ 9163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n_": function() { return /* binding */ AdditionalFeesBase; }
/* harmony export */ });
/* unused harmony exports Fees, NotIncluded, PricesWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3854);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89804);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 8px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  line-height: 1.4;\n  padding-block: 16px;\n  padding-inline: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  margin-block-end: 12px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-block: 0;\n  padding-inline: 4px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var AdditionalFeesBase = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__AdditionalFeesBase",
    componentId: "sc-9f3b0415-0"
})(_templateObject(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey4 */ .O9.grey4, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2);
var Fees = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Fees",
    componentId: "sc-9f3b0415-1"
})(_templateObject1());
var NotIncluded = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "styles__NotIncluded",
    componentId: "sc-9f3b0415-2"
})(_templateObject2());
var PricesWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__PricesWrapper",
    componentId: "sc-9f3b0415-3"
})(_templateObject3());


/***/ }),

/***/ 92142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83112);
/* harmony import */ var client_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72455);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89087);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12524);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);









var ButtonLink = function(_param) {
    var text = _param.text, hasChevron = _param.hasChevron, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "text",
        "hasChevron",
        "className"
    ]);
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        type: "button",
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().buttonLink), className)
    }, props), {
        children: [
            intl.formatMessage({
                id: text
            }),
            hasChevron && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                size: 16
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonLink);


/***/ }),

/***/ 63586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47842);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12524);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72088);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);





function Text(props) {
    var tmp = props.as, Tag = tmp === void 0 ? "p" : tmp, children = props.children, variant = props.variant, weight = props.weight, _align = props.align, align = _align === void 0 ? "start" : _align, className = props.className, loading = props.loading, ellipsis = props.ellipsis, transform = props.transform;
    var _obj;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text), className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().textBodyXl), variant === "textBodyXl"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().textBodyL), variant === "textBodyL"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().textBodyM), variant === "textBodyM"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().textBodyS), variant === "textBodyS"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().titleS), variant === "titleS"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().titleXs), variant === "titleXs"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().captionL), variant === "captionL"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().weight1), weight === "weight1"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().weight2), weight === "weight2"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().weight3), weight === "weight3"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().weight4), weight === "weight4"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().start), align === "start"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().center), align === "center"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().end), align === "end"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().loading), loading), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().ellipsis), ellipsis), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().capitalize), transform === "capitalize"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().capitalizeFirst), transform === "capitalize-first"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().lowercase), transform === "lowercase"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().uppercase), transform === "uppercase"), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        className: classes,
        children: children
    });
}


/***/ }),

/***/ 2091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fq": function() { return /* binding */ MEDIUM_SIZE; },
/* harmony export */   "Ke": function() { return /* binding */ SMALL_SIZE; },
/* harmony export */   "LK": function() { return /* binding */ ICON_MEDIUM_SIZE; },
/* harmony export */   "a6": function() { return /* binding */ ICON_SMALL_SIZE; },
/* harmony export */   "pd": function() { return /* binding */ DESIGN_ICON_LIMIT; }
/* harmony export */ });
var DESIGN_ICON_LIMIT = 3;
var ICON_SMALL_SIZE = 20;
var ICON_MEDIUM_SIZE = 24;
var MEDIUM_SIZE = "MEDIUM_SIZE";
var SMALL_SIZE = "SMALL_SIZE";


/***/ }),

/***/ 52340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_BedType; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./src/comps/BedType/messages.js

var globalMessages = (0,lib/* defineMessages */.vU)({
    beds: {
        id: "room.beds"
    }
});
/* harmony default export */ var messages = (globalMessages);

// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/comps/BedType/styles.js
var styles = __webpack_require__(50978);
// EXTERNAL MODULE: ./client/icons/beds/Double.js
var Double = __webpack_require__(78689);
// EXTERNAL MODULE: ./client/icons/beds/Single.js
var Single = __webpack_require__(64974);
// EXTERNAL MODULE: ./client/icons/createSvgIcon.tsx + 1 modules
var createSvgIcon = __webpack_require__(88121);
;// CONCATENATED MODULE: ./client/icons/beds/SofaBed.js



/* harmony default export */ var SofaBed = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M19 9V7c0-2.2-1.8-4-4-4H9C6.8 3 5 4.8 5 7v2c-1.7 0-3 1.3-3 3v4c0 1.7 1.3 3 3 3v1c0 .6.4 1 1 1s1-.4 1-1v-1h10v1c0 .6.4 1 1 1s1-.4 1-1v-1c1.7 0 3-1.3 3-3v-4c0-1.7-1.3-3-3-3zM7 7c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v2.8c-.6.5-1 1.3-1 2.2v1H8v-1c0-.9-.4-1.7-1-2.2V7zm13 9c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1s1 .4 1 1v2c0 .6.4 1 1 1h10c.6 0 1-.4 1-1v-2c0-.6.4-1 1-1s1 .4 1 1v4z"
}), "SofaBed"));

;// CONCATENATED MODULE: ./client/icons/beds/BunkBed.js



/* harmony default export */ var BunkBed = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M21 6c-.6 0-1 .4-1 1v2h-3V7c0-.6-.4-1-1-1s-1 .4-1 1v2H4V4c0-.6-.4-1-1-1s-1 .4-1 1v17c0 .6.4 1 1 1s1-.4 1-1v-2h11v2c0 .6.4 1 1 1s1-.4 1-1v-2h3v2c0 .6.4 1 1 1s1-.4 1-1V7c0-.6-.4-1-1-1zm-1 5v2h-3v-2h3zM4 17v-6h11v6H4zm13-2h3v2h-3v-2zm-8-1H6c-.6 0-1 .4-1 1s.4 1 1 1h3c.6 0 1-.4 1-1s-.4-1-1-1zm0-6H6c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1s-.4 1-1 1z"
}), "BunkBed"));

// EXTERNAL MODULE: ./src/comps/BedType/constants.js
var constants = __webpack_require__(2091);
;// CONCATENATED MODULE: ./src/comps/BedType/index.js














var BedType = function(param) {
    var _beds = param.beds, beds = _beds === void 0 ? [] : _beds, _size = param.size, size = _size === void 0 ? constants/* SMALL_SIZE */.Ke : _size, _title = param.title, title = _title === void 0 ? true : _title, _hideIcons = param.hideIcons, hideIcons = _hideIcons === void 0 ? false : _hideIcons;
    var getBedIcon = function getBedIcon(type) {
        var finalSize = size === constants/* SMALL_SIZE */.Ke ? constants/* ICON_SMALL_SIZE */.a6 : constants/* ICON_MEDIUM_SIZE */.LK;
        var BED_TYPES = {
            FullBed: /*#__PURE__*/ (0,jsx_runtime.jsx)(Double["default"], {
                size: finalSize
            }),
            QueenBed: /*#__PURE__*/ (0,jsx_runtime.jsx)(Double["default"], {
                size: finalSize
            }),
            KingBed: /*#__PURE__*/ (0,jsx_runtime.jsx)(Double["default"], {
                size: finalSize
            }),
            MurphyBed: /*#__PURE__*/ (0,jsx_runtime.jsx)(Double["default"], {
                size: finalSize
            }),
            WaterBed: /*#__PURE__*/ (0,jsx_runtime.jsx)(Double["default"], {
                size: finalSize
            }),
            TwinBed: /*#__PURE__*/ (0,jsx_runtime.jsx)(Single["default"], {
                size: finalSize
            }),
            TwinXLBed: /*#__PURE__*/ (0,jsx_runtime.jsx)(Single["default"], {
                size: finalSize
            }),
            SofaBed: /*#__PURE__*/ (0,jsx_runtime.jsx)(SofaBed, {
                size: finalSize
            }),
            FutonBed: /*#__PURE__*/ (0,jsx_runtime.jsx)(SofaBed, {
                size: finalSize
            }),
            BunkBed: /*#__PURE__*/ (0,jsx_runtime.jsx)(BunkBed, {
                size: finalSize
            }),
            TrundleBed: /*#__PURE__*/ (0,jsx_runtime.jsx)(BunkBed, {
                size: finalSize
            })
        };
        return BED_TYPES[type];
    };
    if (beds.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* BedTypeBase */.od, {
        size: size,
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                size: size,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, messages.beds), {
                    tagName: "p"
                }))
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BedsWrapper */.is, {
                children: beds.map(function(bed, index) {
                    var items = (0,_to_consumable_array/* default */.Z)(Array(bed === null || bed === void 0 ? void 0 : bed.quantity).keys());
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* BedWrapper */.y, {
                        children: [
                            !hideIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IconWrapper */.a1, {
                                children: items.length <= constants/* DESIGN_ICON_LIMIT */.pd ? items.map(function(item) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: getBedIcon(bed === null || bed === void 0 ? void 0 : bed.type)
                                    }, "icon-".concat(item));
                                }) : getBedIcon(bed === null || bed === void 0 ? void 0 : bed.type)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BedDescription */.oS, {
                                children: "".concat(bed === null || bed === void 0 ? void 0 : bed.quantity, " ").concat(bed === null || bed === void 0 ? void 0 : bed.description)
                            }),
                            index + 1 < beds.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Separator */.Z0, {
                                children: "\xb7"
                            }) : null
                        ]
                    }, "bedtype-".concat(bed === null || bed === void 0 ? void 0 : bed.type));
                })
            })
        ]
    });
};
BedType.propTypes = {
    size: (prop_types_default()).string,
    beds: prop_types_default().arrayOf(prop_types_default().shape({
        type: (prop_types_default()).string,
        description: (prop_types_default()).string,
        quantity: (prop_types_default()).number
    })),
    title: (prop_types_default()).bool,
    hideIcons: (prop_types_default()).bool
};
/* harmony default export */ var comps_BedType = (BedType);


/***/ }),

/***/ 50978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Z0": function() { return /* binding */ Separator; },
/* harmony export */   "a1": function() { return /* binding */ IconWrapper; },
/* harmony export */   "is": function() { return /* binding */ BedsWrapper; },
/* harmony export */   "oS": function() { return /* binding */ BedDescription; },
/* harmony export */   "od": function() { return /* binding */ BedTypeBase; },
/* harmony export */   "y": function() { return /* binding */ BedWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3854);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89804);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2091);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  font-size: 14px;\n\n  color: ",
        ";\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  margin-inline-start: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  > p {\n    &::after {\n      content: ':';\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-inline-end: 8px;\n  align-items: flex-end;\n  width: auto;\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 12px;\n  padding-inline: 4px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var BedTypeBase = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__BedTypeBase",
    componentId: "sc-46def71b-0"
})(_templateObject(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2, function(props) {
    return props.size === _constants__WEBPACK_IMPORTED_MODULE_3__/* .MEDIUM_SIZE */ .Fq && "font-size: 16px";
}, function(props) {
    return props.size === _constants__WEBPACK_IMPORTED_MODULE_3__/* .SMALL_SIZE */ .Ke && "font-size: 14px";
});
var BedsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__BedsWrapper",
    componentId: "sc-46def71b-1"
})(_templateObject1());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Title",
    componentId: "sc-46def71b-2"
})(_templateObject2(), function(props) {
    return props.size === _constants__WEBPACK_IMPORTED_MODULE_3__/* .SMALL_SIZE */ .Ke && "margin-block-start: 4px";
});
var BedWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__BedWrapper",
    componentId: "sc-46def71b-3"
})(_templateObject3());
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__IconWrapper",
    componentId: "sc-46def71b-4"
})(_templateObject4(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2);
var Separator = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Separator",
    componentId: "sc-46def71b-5"
})(_templateObject5());
var BedDescription = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__BedDescription",
    componentId: "sc-46def71b-6"
})(_templateObject6());


/***/ }),

/***/ 48320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_Capacity; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
;// CONCATENATED MODULE: ./src/comps/Capacity/constants.ts
var DEFAULT_GLUE = " \xb7 ";

// EXTERNAL MODULE: ./lib/paxes.ts
var paxes = __webpack_require__(10306);
// EXTERNAL MODULE: ./client/icons/createSvgIcon.tsx + 1 modules
var createSvgIcon = __webpack_require__(88121);
;// CONCATENATED MODULE: ./client/icons/Children.js



/* harmony default export */ var Children = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.333 2C6.65 2 2 6.65 2 12.333c0 5.684 4.65 10.334 10.333 10.334 5.684 0 10.334-4.65 10.334-10.334C22.667 6.65 18.017 2 12.333 2zm0 18.6c-4.546 0-8.266-3.72-8.266-8.267 0-3.513 2.17-6.406 5.166-7.646V5.1c0 1.757 1.344 3.1 3.1 3.1.62 0 1.034-.413 1.034-1.033 0-.62-.414-1.034-1.034-1.034-.62 0-1.033-.413-1.033-1.033 0-.62.413-1.033 1.033-1.033 4.547 0 8.267 3.72 8.267 8.266 0 4.547-3.72 8.267-8.267 8.267z"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.677 14.71c-.207.207-.827.723-1.343.723-.517 0-1.137-.516-1.344-.723a1.107 1.107 0 00-1.446-.103 1.106 1.106 0 00-.104 1.447c.207.206 1.344 1.446 2.894 1.446s2.686-1.24 2.79-1.343c.413-.414.31-1.034-.104-1.447-.31-.413-1.033-.413-1.343 0zM9.233 12.333a1.033 1.033 0 100-2.066 1.033 1.033 0 000 2.066zM15.433 12.333a1.033 1.033 0 100-2.066 1.033 1.033 0 000 2.066z"
        })
    ]
}), "Children"));

// EXTERNAL MODULE: ./client/icons/Person.js
var Person = __webpack_require__(73045);
// EXTERNAL MODULE: ./src/comps/Capacity/styles.ts
var styles = __webpack_require__(6865);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./src/comps/Capacity/messages.ts

var globalMessages = (0,lib/* defineMessages */.vU)({
    capacity: {
        id: "global.capacity"
    },
    adult: {
        id: "global.adult"
    },
    adults: {
        id: "global.adults"
    },
    child: {
        id: "global.child"
    },
    children: {
        id: "global.children"
    },
    childrenAges: {
        id: "global.childrenAges"
    },
    singularChildrenAges: {
        id: "search.year"
    }
});
/* harmony default export */ var messages = (globalMessages);

;// CONCATENATED MODULE: ./src/comps/Capacity/index.tsx
/* eslint-disable no-nested-ternary, react/prop-types */ 











var Capacity = function(param) {
    var adults = param.adults, _children = param.children, children = _children === void 0 ? 0 : _children, childrenAges = param.childrenAges, _glue = param.glue, glue = _glue === void 0 ? DEFAULT_GLUE : _glue, _showAges = param.showAges, showAges = _showAges === void 0 ? true : _showAges, _showIcons = param.showIcons, showIcons = _showIcons === void 0 ? true : _showIcons, _title = param.title, title = _title === void 0 ? true : _title;
    var intl = (0,useIntl/* default */.Z)();
    var messageAdults = messages[adults === 1 ? "adult" : "adults"];
    var messageChildren = messages[children === 1 ? "child" : "children"];
    var agesTotal = (0,paxes/* sumAgesFromString */.ts)(childrenAges);
    var messageChildrenAges = messages[agesTotal === 1 ? "singularChildrenAges" : "childrenAges"];
    var translations = {
        adults: intl.formatMessage(messageAdults),
        children: intl.formatMessage(messageChildren),
        childrenAges: intl.formatMessage(messageChildrenAges, {
            children_ages: childrenAges
        })
    };
    var paxAges = children > 0 ? "(".concat(translations.childrenAges, ")") : "";
    var paxChildren = children > 0 ? showAges ? "".concat(glue).concat(children, " ").concat(translations.children, " ").concat(paxAges) : "".concat(glue).concat(children, " ").concat(translations.children) : "";
    var people = (0,_to_consumable_array/* default */.Z)(Array(adults).keys())// build an array from a number
    ;
    var Icons = function() {
        return children >= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* IconWrapper */.a1, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Person/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Children, {})
            ]
        }) : adults >= 4 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IconWrapper */.a1, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person/* default */.Z, {})
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IconWrapper */.a1, {
            children: people.map(function(pax) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Person/* default */.Z, {}, pax);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CapacityBase */.KJ, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, messages.capacity), {
                tagName: "p"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Paxes */.PS, {
                showIcons: showIcons,
                showTitle: title,
                "data-testid": "capacity-message",
                children: [
                    showIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons, {}),
                    adults >= 4 && showIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Separator */.Z0, {
                        children: " x "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Adults */.w9, {
                        children: "".concat(adults, " ").concat(translations.adults)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Children */.hu, {
                        children: paxChildren
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var comps_Capacity = (Capacity);


/***/ }),

/***/ 61706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var client_icons_Done__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47012);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54697);





var Checkbox = function(param) {
    var className = param.className, error = param.error, _isFocused = param.isFocused, isFocused = _isFocused === void 0 ? false : _isFocused, label = param.label, link = param.link, name = param.name, onChange = param.onChange, onFocus = param.onFocus, _required = param.required, required = _required === void 0 ? false : _required, selected = param.selected, _type = param.type, type = _type === void 0 ? "checkbox" : _type, dataTestId = param.dataTestId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .CheckboxBase */ .A, {
        htmlFor: name,
        isChecked: selected,
        isFocused: isFocused,
        error: error,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                "data-testid": dataTestId,
                role: "checkbox",
                "aria-checked": selected,
                checked: selected,
                id: name,
                name: name,
                onChange: function() {
                    return onChange({
                        name: name
                    });
                },
                onFocus: onFocus,
                type: type
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Done__WEBPACK_IMPORTED_MODULE_2__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                className: className,
                asterisk: required,
                children: link || label
            })
        ]
    });
};
Checkbox.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    error: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    isFocused: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    label: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_4___default().element)
    ]),
    link: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Object),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    onChange: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
    onFocus: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
    required: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    selected: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool.isRequired),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    dataTestId: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 54697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CheckboxBase; },
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3854);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89804);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  margin-block-end: 0.8em;\n  user-select: none;\n\n  > svg {\n    border-radius: 3px;\n    border: 2px solid;\n    flex: 0 0 auto;\n    height: 20px;\n    vertical-align: bottom;\n    width: 20px;\n\n    ",
        "\n  }\n\n  ",
        "\n\n  input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :after {\n        content: '*';\n        color: ",
        ";\n        margin-inline-start: 5px;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  display: inline-block;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.7em;\n  margin-inline-start: 14px;\n  vertical-align: middle;\n\n  a,\n  a:active {\n    color: ",
        ";\n    text-decoration: none;\n    text-transform: lowercase;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var CheckboxBase = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    displayName: "styles__CheckboxBase",
    componentId: "sc-273adab7-0"
})(_templateObject(), function(props) {
    return props.isChecked ? "\n            background-color: ".concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.magenta */ .O9.magenta, ";\n            border-color: ").concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.magenta */ .O9.magenta, ";\n            fill: ").concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.white */ .O9.white, ";\n          ") : "\n            background-color: ".concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.white */ .O9.white, ";\n            border-color: ").concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey4 */ .O9.grey4, ";\n            fill: ").concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.white */ .O9.white, ";\n          ");
}, function(props) {
    return props.isFocused && "svg { border-color: ".concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2, "; }");
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__Text",
    componentId: "sc-273adab7-1"
})(_templateObject2(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .fonts["default"] */ .Rq["default"], function(props) {
    return props.size ? "".concat(props.size, "px") : "16px";
}, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.blue */ .O9.blue, function(props) {
    return props.asterisk && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.magenta */ .O9.magenta);
});


/***/ }),

/***/ 40401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_CheckoutWalletSelector; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
// EXTERNAL MODULE: ./client/contexts/Wallet/actions.js
var actions = __webpack_require__(84923);
// EXTERNAL MODULE: ./src/hooks/useSystem.ts
var useSystem = __webpack_require__(72337);
// EXTERNAL MODULE: ./client/contexts/Login/selectors.js
var selectors = __webpack_require__(80528);
// EXTERNAL MODULE: ./client/contexts/Wallet/selectors.js
var Wallet_selectors = __webpack_require__(30874);
// EXTERNAL MODULE: ./client/components/Price/index.js
var Price = __webpack_require__(50992);
// EXTERNAL MODULE: ./src/comps/Checkbox/index.js
var Checkbox = __webpack_require__(61706);
// EXTERNAL MODULE: ./src/comps/CheckoutWalletSelector/styles.js
var styles = __webpack_require__(55028);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./src/comps/CheckoutWalletSelector/messages.js

var messages = (0,lib/* defineMessages */.vU)({
    useMyCredit: {
        id: "staywallet.use-my-credit"
    }
});
/* harmony default export */ var CheckoutWalletSelector_messages = (messages);

;// CONCATENATED MODULE: ./src/comps/CheckoutWalletSelector/index.js















var CheckoutWalletSelector = function(param) {
    var purchaseId = param.purchaseId;
    var onChange = function onChange() {
        if (isLoading) {
            return;
        }
        if (isWalletChecked) {
            dispatch((0,actions/* uncheckPurchaseWalletRequestAction */.jf)({
                hostname: apiHostName,
                data: {
                    purchaseId: purchaseId
                }
            }));
            return;
        }
        dispatch((0,actions/* checkPurchaseWalletRequestAction */.fc)({
            hostname: apiHostName,
            data: {
                purchaseId: purchaseId
            }
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var apiHostName = (0,useSystem/* useSystem */.u)().apiHostName;
    var ref = (0,react.useState)(false), firstCheckDone = ref[0], setFirstCheckDone = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(Wallet_selectors/* getWalletCredit */.Hg), amount = ref1.amount, currency = ref1.currency;
    var isLoading = (0,es/* useSelector */.v9)(Wallet_selectors/* isFetching */.dF);
    var isLogged = (0,es/* useSelector */.v9)(selectors/* getLoginStatus */.Jb);
    var isWalletChecked = (0,es/* useSelector */.v9)(Wallet_selectors/* isCheck */.lq);
    (0,react.useEffect)(function() {
        if (isLogged) {
            dispatch((0,actions/* fetchWalletRequestAction */.yH)({
                hostname: apiHostName,
                data: {
                    purchaseId: purchaseId
                }
            }));
        }
    }, [
        purchaseId,
        isLogged
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    (0,react.useEffect)(function() {
        if (isLogged && amount && !firstCheckDone) {
            dispatch((0,actions/* fetchAppliedWalletRequestAction */.Ze)({
                hostname: apiHostName,
                data: {
                    purchaseId: purchaseId
                }
            }));
            setFirstCheckDone(true);
        }
    }, [
        amount
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    if (!amount || !isLogged) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CheckoutWalletSelectorBase */.P, {
        "data-testid": "checkout-wallet-selector",
        onClick: onChange,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                name: "staywallet",
                selected: isWalletChecked,
                onChange: function() {}
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, CheckoutWalletSelector_messages.useMyCredit), {
                tagName: "p"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                    amount: -amount,
                    currency: currency
                })
            })
        ]
    });
};
CheckoutWalletSelector.propTypes = {
    purchaseId: (prop_types_default()).string.isRequired
};
/* harmony default export */ var comps_CheckoutWalletSelector = (CheckoutWalletSelector);


/***/ }),

/***/ 55028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ CheckoutWalletSelectorBase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3854);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89804);
/* harmony import */ var src_comps_Checkbox_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54697);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-block: 16px;\n  padding-inline: 16px;\n  border: 2px solid ",
        ";\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  ",
        " {\n    flex: 1 0 auto;\n    margin-block-end: 0;\n    pointer-events: none;\n  }\n\n  > p {\n    flex: 1 1 auto;\n  }\n\n  > span {\n    margin-inline-start: 10px;\n    flex: 0 0 auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var CheckoutWalletSelectorBase = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CheckoutWalletSelectorBase",
    componentId: "sc-ad162702-0"
})(_templateObject(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey4 */ .O9.grey4, src_comps_Checkbox_styles__WEBPACK_IMPORTED_MODULE_2__/* .CheckboxBase */ .A);


/***/ }),

/***/ 14686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63557);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var client_icons_notification_Error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97071);
/* harmony import */ var client_icons_notification_Info__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52723);
/* harmony import */ var client_icons_notification_Warning__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3369);
/* harmony import */ var client_icons_notification_Success__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52067);







var MESSAGE_TYPES = [
    "info",
    "warning",
    "success",
    "error"
];
var iconMap = {
    info: client_icons_notification_Info__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
    warning: client_icons_notification_Warning__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
    success: client_icons_notification_Success__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
    error: client_icons_notification_Error__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
};
var MessageBox = function(param) {
    var message = param.message, type = param.type;
    var messageType = !MESSAGE_TYPES.includes(type) ? "info" : type;
    var Icon = iconMap[messageType];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default())[messageType],
        role: "note",
        children: [
            Icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: message
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MessageBox);


/***/ }),

/***/ 66967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Molecules_Conditions; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 108 modules
var src = __webpack_require__(79000);
// EXTERNAL MODULE: ./client/components/HtmlViewer/index.js
var HtmlViewer = __webpack_require__(1987);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/comps/Atom/Buttons/ButtonLink/index.tsx
var ButtonLink = __webpack_require__(92142);
// EXTERNAL MODULE: ./src/comps/Atom/Text/index.tsx
var Text = __webpack_require__(63586);
// EXTERNAL MODULE: ../../node_modules/lodash/compact.js
var compact = __webpack_require__(60417);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ./client/icons/ArrowDown.js
var ArrowDown = __webpack_require__(53589);
// EXTERNAL MODULE: ./client/icons/ArrowUp.js
var ArrowUp = __webpack_require__(89855);
// EXTERNAL MODULE: ./src/hooks/useToggle/index.ts
var useToggle = __webpack_require__(83847);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./src/comps/ShowMore/messages.js

var messages = (0,lib/* defineMessages */.vU)({
    showMore: {
        id: "global.show-more"
    },
    showLess: {
        id: "global.show-less"
    }
});
/* harmony default export */ var ShowMore_messages = (messages);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(3854);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./src/comps/ShowMore/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  color: ",
        ";\n  cursor: pointer;\n  display: flex;\n  font-size: 14px;\n  line-height: 20px;\n  text-decoration: underline;\n\n  svg {\n    margin-inline-start: 8px;\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ShowMoreBase = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ShowMoreBase",
    componentId: "sc-9455cc26-0"
})(_templateObject(), styles/* colors.grey1 */.O9.grey1, styles/* colors.grey1 */.O9.grey1);

;// CONCATENATED MODULE: ./src/comps/ShowMore/index.tsx










var DEFAULT_BLOCKS_TO_SHOW = 2;
var ShowMore = function(param) {
    var children = param.children, _blocksToShow = param.blocksToShow, blocksToShow = _blocksToShow === void 0 ? DEFAULT_BLOCKS_TO_SHOW : _blocksToShow, _showAll = param.showAll, showAll = _showAll === void 0 ? false : _showAll;
    var ref = (0,useToggle/* default */.Z)({
        value: false
    }), toggled = ref.value, toggle = ref.toggle;
    var childrenWithContent = (0,react.useMemo)(function() {
        return compact_default()(react.Children.toArray(children));
    }, [
        children
    ]);
    var showChildren = (0,react.useMemo)(function() {
        return toggled || showAll ? childrenWithContent : childrenWithContent.slice(0, blocksToShow);
    }, [
        toggled,
        childrenWithContent,
        blocksToShow,
        showAll
    ]);
    var translation = toggled ? ShowMore_messages.showLess : ShowMore_messages.showMore;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showChildren,
            childrenWithContent.length > blocksToShow && !showAll && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShowMoreBase, {
                onClick: toggle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, translation)),
                    toggled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var comps_ShowMore = (ShowMore);

// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/index.ts
var useKafkaEvent = __webpack_require__(96128);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/constants.ts
var constants = __webpack_require__(18935);
// EXTERNAL MODULE: ./src/hooks/usePage/index.ts
var usePage = __webpack_require__(73250);
;// CONCATENATED MODULE: ./src/comps/Molecules/Conditions/helpers.ts
var defaultProps = {
    checkin: {
        beginTime: "15:00",
        endTime: "6:00",
        instructions: "<ul>  <li>Puede aplicarse un recargo por cada persona adicional, seg\xfan la pol\xedtica del alojamiento.</li><li>A tu llegada, pueden pedirte un documento de identidad oficial con foto y una tarjeta de cr\xe9dito o d\xe9bito, o un dep\xf3sito en efectivo, para cubrir los gastos imprevistos.</li><li>No se garantizan las solicitudes especiales, que est\xe1n sujetas a disponibilidad en el momento de la llegada y pueden suponer un recargo adicional.</li><li>El nombre de la tarjeta de cr\xe9dito utilizada a la llegada para pagar gastos adicionales debe corresponderse con el nombre principal que figura en la reserva de la habitaci\xf3n.</li><li>Este alojamiento acepta tarjetas de cr\xe9dito, tarjetas de d\xe9bito y efectivo.</li><li>Entre los elementos de seguridad de este alojamiento, se incluyen los siguientes: detector de humo y sistema de seguridad.</li><li>Las normas culturales y las pol\xedticas para hu\xe9spedes pueden variar seg\xfan el pa\xeds y el establecimiento, que es el que dicta las pol\xedticas que aqu\xed se muestran.</li>  </ul> <ul>  <li>Los hu\xe9spedes con animales de servicio deben ponerse en contacto con el establecimiento con antelaci\xf3n.</li>  </ul>",
        specialInstructions: "Este alojamiento no permite realizar el registro de entrada fuera del horario establecido. El personal de recepci\xf3n estar\xe1 esperando a los hu\xe9spedes a su llegada. Para obtener m\xe1s informaci\xf3n, ponte en contacto con el alojamiento usando los datos que aparecen en la confirmaci\xf3n de la reserva.  Este alojamiento se encuentra en la zona de bajas emisiones de la ciudad, por lo que solo se permite acceder con veh\xedculos de bajas emisiones. Los hu\xe9spedes con matr\xedcula extranjera deben registrar su veh\xedculo con antelaci\xf3n. Debido al COVID-19, las opciones de alimentos y bebidas de este alojamiento pueden estar limitadas siguiendo la normativa local.",
        minAge: 0
    },
    checkout: {
        time: "12:00"
    },
    fees: {
        mandatory: "<p>Los siguientes cargos se pagan en el alojamiento: </p> <ul><li>Tasa municipal: 1.21 EUR por persona y por noche, hasta un m\xe1ximo de 7 noches. Esta tasa no se aplica a menores de 17 a\xf1os.</li> </ul> <p>Hemos incluido todos los cargos que nos ha proporcionado el alojamiento. </p>",
        optional: "<p>Los siguientes cargos y dep\xf3sitos se pagan directamente en el hotel al recibir el servicio, a la llegada o a la salida: </p> <ul> <li>Desayuno tipo buf\xe9: 15 EUR por persona (precio aproximado)</li>       <li>Aparcamiento: 23.76 EUR por d\xeda</li>                       </ul> <p>La lista anterior puede estar incompleta. Adem\xe1s, es posible que los impuestos no est\xe9n incluidos. Importes sujetos a cambios. </p>"
    },
    policies: {
        knowBeforeYouGo: '<ul>  <li>De acuerdo con la normativa nacional, este alojamiento no acepta pagos en efectivo que superen los 2500 EUR. Para m\xe1s informaci\xf3n, ponte en contacto con el alojamiento a trav\xe9s de los datos que figuran en la confirmaci\xf3n de la reserva. </li><li>Hay habitaciones comunicadas o contiguas, sujetas a disponibilidad. Es posible solicitarlas directamente al alojamiento, a trav\xe9s de los datos de contacto que figuran en la confirmaci\xf3n de reserva. </li><li>Este alojamiento indica que ha implementado medidas de limpieza adicional y de seguridad de los hu\xe9spedes.</li><li>La limpieza se efect\xfaa con desinfectante, las superficies de contacto habitual se limpian con desinfectante entre una estancia y otra y las s\xe1banas y las toallas se lavan a 60\xba C o m\xe1s.</li><li>Se ofrece equipo de protecci\xf3n individual, como mascarillas y guantes, a los hu\xe9spedes.</li><li>Se aplican medidas de distanciamiento social; el personal lleva un equipo de protecci\xf3n individual; hay paneles de separaci\xf3n entre los hu\xe9spedes y el personal en las principales zonas de contacto y se proporciona desinfectante de manos a los hu\xe9spedes.</li><li>Es posible realizar el registro de entrada sin contacto personal y el registro de salida sin contacto personal.</li><li>Se ofrece comida envasada individualmente para el desayuno y a trav\xe9s del servicio de habitaciones.</li><li>Cada habitaci\xf3n permanece vac\xeda durante un m\xednimo de 48 horas entre reservas.</li><li>El alojamiento afirma que sigue las medidas de limpieza y desinfecci\xf3n de Safe Tourism Certified (Espa\xf1a).</li> </ul><ul>  <li>Para obtener m\xe1s informaci\xf3n sobre la pol\xedtica de privacidad de Best Western, visita <a href="www.bestwestern.com/privacy" target="_blank">www.bestwestern.com/privacy</a>.</li>  </ul>'
    },
    comments: "Test comments"
};
var emptyProps = {
    checkin: {
        beginTime: "",
        endTime: "",
        instructions: "",
        specialInstructions: "",
        minAge: 0
    },
    checkout: {
        time: ""
    },
    fees: {
        mandatory: "",
        optional: ""
    },
    policies: {
        knowBeforeYouGo: ""
    },
    comments: ""
};
var countBlocksWithContent = function(blocks) {
    return Object.keys(blocks).map(function(key) {
        return (typeof blocks[key] === "object" && !Array.isArray(blocks[key]) && blocks[key] !== null ? Object.values(blocks[key]) : [
            blocks[key]
        ]).some(function(value) {
            return !!value;
        });
    }).filter(function(value) {
        return value;
    }).length;
};


;// CONCATENATED MODULE: ./src/comps/Molecules/Conditions/messages.ts

var messages_messages = (0,lib/* defineMessages */.vU)({
    title: {
        id: "global.checkin-important-information"
    },
    checkIn: {
        id: "search.checkin"
    },
    checkOut: {
        id: "search.checkout"
    },
    checkInTime: {
        id: "global.checkin-time"
    },
    checkOutTime: {
        id: "global.checkout-time"
    },
    showMore: {
        id: "global.show-more"
    },
    showLess: {
        id: "global.show-less"
    },
    instructions: {
        id: "global.instructions"
    },
    specialInstructions: {
        id: "global.special-instructions"
    },
    fees: {
        id: "global.fees"
    },
    policies: {
        id: "global.policies"
    },
    additionalInformation: {
        id: "global.additional-information"
    },
    minAge: {
        id: "global.minimum-checkin-age"
    }
});
/* harmony default export */ var Conditions_messages = (messages_messages);

;// CONCATENATED MODULE: ./src/comps/Molecules/Conditions/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-block: 20px;\n  padding-inline: 0;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 18px;\n  line-height: 1.2;\n  font-weight: 700;\n  margin-block-end: 20px;\n\n  ",
        " {\n    font-size: 28px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 700;\n  margin-block-end: 6px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 16px;\n  line-height: 24px;\n  margin-block-end: 20px;\n\n  p {\n    margin-block-start: 6px;\n  }\n\n  ul,\n  ol {\n    list-style: disc;\n    margin-inline-start: 30px;\n  }\n\n  li {\n    font-size: 16px;\n    line-height: 24px;\n    margin-block-end: 6px;\n    padding-inline-start: 5px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var ConditionsBase = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ConditionsBase",
    componentId: "sc-268659d9-0"
})(styles_templateObject(), styles/* colors.white */.O9.white);
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__Title",
    componentId: "sc-268659d9-1"
})(_templateObject1(), styles/* colors.grey1 */.O9.grey1, styles/* media.tablet */.BC.tablet);
var SubTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__SubTitle",
    componentId: "sc-268659d9-2"
})(_templateObject2(), styles/* colors.grey1 */.O9.grey1);
var TextStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TextStyle",
    componentId: "sc-268659d9-3"
})(_templateObject3(), styles/* colors.grey2 */.O9.grey2);

// EXTERNAL MODULE: ./src/comps/Molecules/Conditions/styles.module.css
var styles_module = __webpack_require__(68531);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/Conditions/index.tsx
















var Checkin = function(param) {
    var beginTime = param.beginTime, endTime = param.endTime, _minAge = param.minAge, minAge = _minAge === void 0 ? 0 : _minAge;
    if (!beginTime && !endTime) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, Conditions_messages.checkIn))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextStyle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, Conditions_messages.checkInTime)),
                    " ".concat(beginTime, " - ").concat(endTime, " "),
                    !!minAge && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, Conditions_messages.minAge)),
                            ": ".concat(minAge)
                        ]
                    })
                ]
            })
        ]
    });
};
var Checkout = function(param) {
    var time = param.time;
    if (!time) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, Conditions_messages.checkOut))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextStyle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, Conditions_messages.checkOutTime)),
                    " ".concat(time)
                ]
            })
        ]
    });
};
var Instructions = function(param) {
    var instructions = param.instructions;
    if (!instructions) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, Conditions_messages.instructions))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextStyle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                    html: instructions
                })
            })
        ]
    });
};
var SpecialInstructions = function(param) {
    var specialInstructions = param.specialInstructions;
    if (!specialInstructions) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, Conditions_messages.specialInstructions))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextStyle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                    html: specialInstructions
                })
            })
        ]
    });
};
var Fees = function(param) {
    var mandatory = param.mandatory, optional = param.optional;
    if (!mandatory && !optional) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, Conditions_messages.fees))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextStyle, {
                "data-testid": "fees",
                children: [
                    mandatory && /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                        html: mandatory
                    }),
                    optional && /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                        html: optional
                    })
                ]
            })
        ]
    });
};
var Policies = function(param) {
    var knowBeforeYouGo = param.knowBeforeYouGo;
    if (!knowBeforeYouGo) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, Conditions_messages.policies))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextStyle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                    html: knowBeforeYouGo
                })
            })
        ]
    });
};
var AdditionalComments = function(param) {
    var comments = param.comments;
    if (!comments || !comments.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, Conditions_messages.additionalInformation))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextStyle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                    html: comments
                })
            })
        ]
    });
};
var Conditions = function(props) {
    var checkin = props.checkin, checkout = props.checkout, fees = props.fees, policies = props.policies, comments = props.comments, onModal = props.onModal;
    var conditionsWithContent = (0,react.useMemo)(function() {
        return countBlocksWithContent(props);
    }, [
        props
    ]);
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var checkInRef = (0,react.useRef)(null);
    var instructionsRef = (0,react.useRef)(null);
    var feesRef = (0,react.useRef)(null);
    var policiesRef = (0,react.useRef)(null);
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var sendEvent = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId,
        eventName: "open_important_information"
    }).sendEvent;
    var refs = {
        checkInRef: checkInRef,
        instructionsRef: instructionsRef,
        feesRef: feesRef,
        policiesRef: policiesRef
    };
    if (!conditionsWithContent) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var openDescription = function(key) {
        setIsOpen(true);
        requestAnimationFrame(function() {
            var ref;
            (ref = refs[key].current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                block: "end"
            });
        });
        sendEvent({
            section: constants/* SECTIONS.HOTEL_IMPORTANT_INFO */.SA.HOTEL_IMPORTANT_INFO
        }, {
            item: key
        });
    };
    if (onModal) {
        var ref1, ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: (styles_module_default()).comments,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyUp: function() {
                        return openDescription("checkInRef");
                    },
                    onClick: function() {
                        return openDescription("checkInRef");
                    },
                    children: (checkin.beginTime || checkin.endTime || checkout.time) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                        className: (styles_module_default()).checkinContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "dt",
                                        variant: "textBodyM",
                                        children: intl.formatMessage({
                                            id: "search.checkin"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "dd",
                                        variant: "textBodyL",
                                        weight: "weight3",
                                        children: " ".concat(checkin.beginTime, " - ").concat(checkin.endTime, " ")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).lineContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).circle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "100%",
                                        height: "2px",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        preserveAspectRatio: "none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                            x1: "0",
                                            y1: "1",
                                            x2: "100%",
                                            y2: "1",
                                            strokeWidth: "2",
                                            strokeDasharray: "4 4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).circle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).alignEnd,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "dt",
                                        variant: "textBodyM",
                                        children: intl.formatMessage({
                                            id: "search.checkout"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "dd",
                                        variant: "textBodyL",
                                        weight: "weight3",
                                        children: checkout.time
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).linkWrapper,
                    children: [
                        (checkin.instructions || checkin.specialInstructions) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                            onClick: function() {
                                return openDescription("instructionsRef");
                            },
                            text: "global.instructions"
                        }),
                        (fees.mandatory || fees.optional) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                            onClick: function() {
                                return openDescription("feesRef");
                            },
                            text: "global.fees"
                        }),
                        policies.knowBeforeYouGo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                            onClick: function() {
                                return openDescription("policiesRef");
                            },
                            text: "global.policies"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet */.R1, {
                    open: isOpen,
                    onClose: function() {
                        return setIsOpen(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* BottomSheet.Content */.R1.Content, {
                        title: intl.formatMessage({
                            id: "global.checkin-important-information"
                        }),
                        modalOnDesktop: true,
                        scroll: true,
                        children: [
                            checkin.beginTime && checkin.endTime ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).textWrapper,
                                ref: checkInRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "h3",
                                        variant: "textBodyL",
                                        weight: "weight3",
                                        children: intl.formatMessage({
                                            id: "search.checkin"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                        as: "p",
                                        variant: "textBodyL",
                                        children: [
                                            intl.formatMessage({
                                                id: "global.checkin-time"
                                            }),
                                            " ".concat(checkin.beginTime, " - ").concat(checkin.endTime, " ")
                                        ]
                                    }),
                                    !!checkin.minAge && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                        as: "p",
                                        variant: "textBodyL",
                                        children: [
                                            intl.formatMessage({
                                                id: "global.minimum-checkin-age"
                                            }),
                                            ": ".concat(checkin.minAge)
                                        ]
                                    })
                                ]
                            }) : null,
                            checkout.time ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).textWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "h3",
                                        variant: "textBodyL",
                                        weight: "weight3",
                                        children: intl.formatMessage({
                                            id: "search.checkout"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                        as: "p",
                                        variant: "textBodyL",
                                        children: [
                                            intl.formatMessage({
                                                id: "global.checkout-time"
                                            }),
                                            " ".concat(checkout.time)
                                        ]
                                    })
                                ]
                            }) : null,
                            checkin.instructions ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).textWrapper,
                                ref: instructionsRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "h3",
                                        variant: "textBodyL",
                                        weight: "weight3",
                                        children: intl.formatMessage({
                                            id: "global.instructions"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "p",
                                        variant: "textBodyL",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                                            html: checkin.instructions
                                        })
                                    })
                                ]
                            }) : null,
                            checkin.specialInstructions ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).textWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "h3",
                                        variant: "textBodyL",
                                        weight: "weight3",
                                        children: intl.formatMessage({
                                            id: "global.special-instructions"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "p",
                                        variant: "textBodyL",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                                            html: checkin.specialInstructions
                                        })
                                    })
                                ]
                            }) : null,
                            fees.mandatory || fees.optional ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).textWrapper,
                                ref: feesRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "h3",
                                        variant: "textBodyL",
                                        weight: "weight3",
                                        children: intl.formatMessage({
                                            id: "global.fees"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                        as: "p",
                                        variant: "textBodyL",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                                                html: (ref1 = fees === null || fees === void 0 ? void 0 : fees.mandatory) !== null && ref1 !== void 0 ? ref1 : ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                                                html: (ref2 = fees === null || fees === void 0 ? void 0 : fees.optional) !== null && ref2 !== void 0 ? ref2 : ""
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            policies.knowBeforeYouGo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).textWrapper,
                                ref: policiesRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "h3",
                                        variant: "textBodyL",
                                        weight: "weight3",
                                        children: intl.formatMessage({
                                            id: "global.policies"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "p",
                                        variant: "textBodyL",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                                            html: policies.knowBeforeYouGo
                                        })
                                    })
                                ]
                            }) : null,
                            comments ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).textWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "h3",
                                        variant: "textBodyL",
                                        weight: "weight3",
                                        children: intl.formatMessage({
                                            id: "global.additional-information"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "p",
                                        variant: "textBodyL",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                                            html: comments
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionsBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, Conditions_messages.title))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(comps_ShowMore, {
                blocksToShow: 3,
                children: [
                    checkin.beginTime && checkin.endTime ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkin, {
                        beginTime: checkin.beginTime,
                        endTime: checkin.endTime,
                        minAge: checkin === null || checkin === void 0 ? void 0 : checkin.minAge
                    }) : null,
                    checkout.time ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkout, {
                        time: checkout.time
                    }) : null,
                    checkin.instructions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Instructions, {
                        instructions: checkin.instructions
                    }) : null,
                    checkin.specialInstructions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialInstructions, {
                        specialInstructions: checkin.specialInstructions
                    }) : null,
                    fees.mandatory || fees.optional ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Fees, {
                        mandatory: fees.mandatory,
                        optional: fees.optional
                    }) : null,
                    policies.knowBeforeYouGo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Policies, {
                        knowBeforeYouGo: policies.knowBeforeYouGo
                    }) : null,
                    comments ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AdditionalComments, {
                        comments: comments
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var Molecules_Conditions = (Conditions);


/***/ }),

/***/ 83847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_CHANGE_HANDLER */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54073);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable react-hooks/exhaustive-deps */ 

var DEFAULT_CHANGE_HANDLER = function() {
    return null;
};
var useToggle = function(param) {
    var value = param.value, _onChange = param.onChange, onChange = _onChange === void 0 ? DEFAULT_CHANGE_HANDLER : _onChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), toggled = ref[0], setToggled = ref[1];
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        setToggled(function(prev) {
            return !prev;
        });
        onChange(toggled);
    }, 500, {
        leading: true,
        trailing: false
    }), [
        onChange
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (value === toggled) return;
        setToggled(value);
    }, [
        value
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            handleClick.cancel();
        };
    }, []);
    return {
        value: toggled,
        toggle: handleClick
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useToggle);


/***/ }),

/***/ 55313:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trigger":"styles_trigger__8jtWH"};

/***/ }),

/***/ 80646:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"offerConditionsContainer":"styles_offerConditionsContainer__xTGI_","offerConditionsList":"styles_offerConditionsList__eJlam","textWithIcon":"styles_textWithIcon__lrUAG","greenText":"styles_greenText__kWG0x","boldBlack":"styles_boldBlack__0SDWU","greenIcon":"styles_greenIcon__kpSR2","boardInfoButton":"styles_boardInfoButton__mLW0I system_resetButton__nOoOv","info":"styles_info__uENC6","detailContainer":"styles_detailContainer__d2Jih","detailTitle":"styles_detailTitle__4est5","listDoted":"styles_listDoted__Bw2ql"};

/***/ }),

/***/ 89087:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonLink":"styles_buttonLink__lnfup system_textBodyL__xkApD"};

/***/ }),

/***/ 72088:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__c84Sn","textBodyXl":"styles_textBodyXl__gx_0w system_textBodyXL__3G5bt","textBodyL":"styles_textBodyL__2ZohV system_textBodyL__xkApD","textBodyM":"styles_textBodyM__mjgP6 system_textBodyM__ZzPjG","textBodyS":"styles_textBodyS__IiALF system_textBodyS__oWtKd","titleXs":"styles_titleXs__q0HXp system_titleXs__EJJjY","titleS":"styles_titleS__4da8D system_titleS__cGmX6","captionL":"styles_captionL__jJGVK system_captionL__E1FNu","weight1":"styles_weight1__gSMIO","weight2":"styles_weight2__W4FXd","weight3":"styles_weight3__FEClI","weight4":"styles_weight4__Lk6tZ","start":"styles_start__byHoV","center":"styles_center__sw1vT","end":"styles_end__9z_5v","loading":"styles_loading__NisDy","shimmer":"styles_shimmer__ZDO1_","ellipsis":"styles_ellipsis__mxfV5","capitalize":"styles_capitalize__EdEVS","capitalizeFirst":"styles_capitalizeFirst__9jHoS","lowercase":"styles_lowercase__UG4P5","uppercase":"styles_uppercase__u8Fwb"};

/***/ }),

/***/ 63557:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__dPJpX","error":"styles_error__Dgo1L","warning":"styles_warning__BOVZK","success":"styles_success__M6yQ5"};

/***/ }),

/***/ 68531:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"comments":"styles_comments__2iDet","checkinContainer":"styles_checkinContainer__0bu_O","alignEnd":"styles_alignEnd__Pnyyb","lineContainer":"styles_lineContainer__fZLPi","circle":"styles_circle__8Fk2s","linkWrapper":"styles_linkWrapper__dpoyy","textWrapper":"styles_textWrapper__j3I8Y"};

/***/ })

}]);